// @flow
import { AuthService } from '@locus-taxy/auth-react';
import history from 'common/middleware/history';
import type { Dispatch } from 'redux';
import type { Location } from 'react-router-dom';
import genAbsoluteURL from 'common/utils/genAbsoluteURL';
import { deleteSession } from 'common/redux/actions/session';
import { LocusApiModel } from 'common/modules/api';
import type { AppState } from 'common/redux/reducers';
import { getLogoutRedirectUrl } from 'common/redux/selectors/sessionSelector';

class AuthenticationActions {
    static localLogoutOnPasswordChange() {
        return () => {
            AuthService.logout({ localOnly: true });
            // cleanup auth header
            LocusApiModel.removeHeader(AuthService.getAuthHeader()?.key);
        };
    }

    /**
     * @description deletes the session, &
     * calls auth.logout
     */
    static logout({ returnTo }: { returnTo?: string } = {}) {
        return (dispatch: Dispatch<*>, getState: () => AppState) => {
            const returnToURL = getLogoutRedirectUrl(getState()) ?? returnTo;
            AuthService.logout({
                returnTo:
                    returnToURL ??
                    genAbsoluteURL(history.createHref({ pathname: '/login' }))
            });
            dispatch(deleteSession());
        };
    }
    /**
     * @description calls .logout with the correct returnTo URL,
     * created using router history
     */
    static logoutFromLocation({
        currentLocation
    }: { currentLocation: Location } = {}) {
        return (dispatch: Dispatch<any>) => {
            let returnTo;
            if (currentLocation) {
                returnTo = genAbsoluteURL(history.createHref(currentLocation));
            }
            dispatch(AuthenticationActions.logout({ returnTo }));
        };
    }
}

export { AuthenticationActions };
export default AuthenticationActions;
